import { esApp } from './plataforma';

/** A dónde apuntar si un binario se compila sin `REACT_APP_APP_URL`: mejor producción que localhost. */
export const URL_PUBLICA_POR_DEFECTO = 'https://app.arcadigital.app';

/**
 * La dirección pública de la aplicación: la que se puede mandar a otra persona o a otro servicio.
 *
 * En la web es `window.location.origin`. Dentro de la app NO: la página se sirve desde el propio
 * binario y su origen es `https://localhost` (Android) o `capacitor://localhost` (iOS). Un enlace
 * de invitación o una dirección de vuelta del KYC construidos con eso no llevan a ningún sitio.
 * Ahí se usa la web del entorno, que llega en `REACT_APP_APP_URL` al compilar.
 */
export const origenPublico = (
	urlDelEntorno: string | undefined = process.env.REACT_APP_APP_URL
): string => {
	if (!esApp()) {
		return window.location.origin;
	}

	return (urlDelEntorno?.trim() || URL_PUBLICA_POR_DEFECTO).replace(/\/+$/, '');
};

/**
 * ¿Es la máquina de un desarrollador? Para lo que solo debe verse al programar.
 *
 * 🔴 Mirar solo `hostname === 'localhost'` no vale: el WebView de la app también se llama así, y
 * lo que fuera «solo en local» acabaría delante de los usuarios en las tiendas.
 */
export const esEntornoLocal = (hostname: string = window.location.hostname): boolean =>
	!esApp() && hostname === 'localhost';
